import Swiper from 'swiper/bundle';

const triggerClickOnSlideChange = function () {
  const swiper = this;
  const activeSlideIndex = swiper.realIndex;
  const activeSlide = swiper.slides[activeSlideIndex];
  // simulate click on index
  if (activeSlide.onclick) {
    activeSlide.onclick();
  } else if (activeSlide.click) {
    activeSlide.click();
  } else {
    activeSlide.dispatchEvent(new Event('click'));
  }
};

const configs = {
  /**
   * Default for books
   */
  'books': {
    grabCursor: true,
    slidesPerView: 1.5,
    spaceBetween: 32,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 36,
      }
    }
  },

  /**
   * Default for auteurs
   */
  'auteurs': {
    grabCursor: true,
    slidesPerView: 1.5,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 4,
      }
    }
  },

  /**
   * Default for articles
   */
  'articles': {
    grabCursor: true,
    slidesPerView: 1.5,
    spaceBetween: 15,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 36,
      }
    }
  },

  /**
   * Books with enhanced first book
   */
  'books-enhanced': {
    slidesPerView: 'auto',
    loop: true,
    updateOnWindowResize: true
  },

  /**
   * Indexes
   */
  'indexes': {
    slidesPerView: 'auto',
    centeredSlides: true,
    slideToClickedSlide: true,
    hashNavigation: true,
    on: {
      activeIndexChange: triggerClickOnSlideChange
    }
  },

  /**
   * Indexes, aligned on left
   */
  'indexes-left': {
    slidesPerView: 'auto',
    slideToClickedSlide: true,
    hashNavigation: true,
    on: {
      activeIndexChange: triggerClickOnSlideChange,
      init: function () {
        const swiper = this;
        const $swiper = jQuery(swiper.$el);
        const $elements = $swiper.find('.swiper-slide');
        const setActive = function (e) {
          const elementClicked = e.target
          $elements.each((i, element) => {
            if(element.classList.contains('active')){
              element.classList.remove("active");
            }
          });

          if(!elementClicked.classList.contains('active')){
            elementClicked.classList.add('active')
          }
        }
        $elements.each((i, element) => {
          element.addEventListener('click', setActive)
        });
        // set first element as active by default
        $elements[0].click();
      }
    }
  },

  /**
   * Categories
   */
  'categories-books': {
    grabCursor: true,
    slidesPerView: 1.5,
    spaceBetween: 32,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 36,
      }
    }
  },

  /**
   * Videos
   */
  'videos': {
    slidesPerColumn: 7,
    slidesPerColumnFill: 'row'
  },

  /**
   * Bookstores and Press reviews
   */
  'reviews': {
    slidesPerColumn: 1,
    slidesPerColumnFill: 'row',
    observer: true,
    breakpoints: {
      1024: {
        slidesPerColumn: 2,
      }
    }
  },

  /**
   * Extraits on full width
   */
  'extracts-full-width': {
    slidesPerView: 'auto',
    hashNavigation: true,
  },

  /**
   * A la Une
   */
  'slides-highlight': {
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    on: {
      slideChange: function () {
        const swiper = this;
        const nextSlide = swiper.slides[swiper.activeIndex];
        const slideId = nextSlide.getAttribute('data-slider-illustration');
        const slideToShow = document.querySelector(`[data-slider-content="${slideId}"]`);
        const slideContents = document.querySelectorAll('[data-slider-content]');
        if (slideContents.length) {
          slideContents.forEach(slide => {
            slide.classList.remove('visible');
          })
        }
        slideToShow.classList.add('visible');
      }
    }
  },
  on: {
    slideChange: function(sw) {
      this.el.getElement('.swiper-slide.on').removeClass('on');
      this.slides[this.activeIndex].addClass('on');
    },
    imagesReady: function() {
      this.slides[0].addClass('on');
    }
  },
}

function init() {
  const $carousels = jQuery('[data-carousel]');
  if (!$carousels) return
  initCarousels($carousels);
}

function initCarousels($carousels) {
  $carousels.each(function(index, element) {
    var $this = jQuery(this);
    let type = $this.data('carousel');
    $this.addClass('carousel-instance-' + index);
    $this.find('.swiper-container').addClass('carousel-container-' + index);
    $this.find('.swiper-container').data('carousel-index', index);
    $this.find('.carousel-arrow-prev').addClass('carousel-arrow-prev-' + index);
    $this.find('.carousel-arrow-next').addClass('carousel-arrow-next-' + index);
    $this.find('.carousel-pagination').addClass('carousel-pagination-' + index);
    if ( ! configs.hasOwnProperty(type)) {
      type = 'books';
    }
    let options = configs[type];
    if ($this.find('.carousel-pagination').length) {
      options.pagination = {
        el: '.carousel-pagination-' + index,
        clickable: true
      }
    }
    options.watchOverflow = true;
    options.navigation = {
      nextEl: '.carousel-arrow-next-' + index,
      prevEl: '.carousel-arrow-prev-' + index,
    };

    var swiper = new Swiper('.carousel-container-' + index, options);
  });
}

export default { init }
